import { css } from "styled-components";

const resetStyle = css`
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100 %;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section {
    display: block;
  }
  /* HTML5 hidden-attribute fix for newer browsers */
  * [hidden] {
    display: none;
  }
  body {
    line-height: 1;
    font-family: "Roboto", sans-serif;
    background: #f8f8fb;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote: before, blockquote: after,
  q: before, q: after {
    content: "";
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  /* http://www.paulirish.com/2012/box-sizing-border-box-ftw/ (2015/04/28)*/
  html {
    box-sizing: border-box;
  }
  html,
  body {
    height: 100%;
  }
  #root {
    height: inherit;
  }

  *, *: before, *: after {
    box-sizing: inherit;
  }
  /* Additional resets */
  a {
    text-decoration: none;
    color: inherit;
  }
  button {
    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: inherit;
    outline: none;
    line-height: inherit;
    -webkit-appearance: none;
  }
  /* Fix antialiasing */
  *, *: before, *: after {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  /* Disable user select on everything but texts */
  *, *: before, *: after {
    user-select: none;
  }
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  blockquote,
  pre,
  ul,
  ol,
  li,
  table,
  tr,
  th,
  td,
  input,
  textarea {
    user-select: text;
  }
  /* SCROLLBAR */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: #ababab60;
  }

  /* TABLE COMPONENT */
  .ReactVirtualized__Grid__innerScrollContainer {
    width: 100% !important;
  }
  .ReactVirtualized__Table__Grid {
    outline: none;
    width: 100% !important;
  }
  .ReactVirtualized__Table {
    width: 100% !important;
  }

  .ReactVirtualized__Table__headerColumn {
    outline: none;
    flex: 1 !important;
    margin: 0;
    padding-bottom: 10px;
    padding-top: 10px;
  }

  @media (max-width: 1280px) {
    .ReactVirtualized__Table__headerColumn {
      outline: none;
      flex: auto !important;
      margin: 0;
      padding-bottom: 10px;
      padding-top: 10px;
    }

    .column-header-wrapper {
      padding: 0px !important;
    }

    .ReactVirtualized__Table__rowColumn {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }

  .ReactVirtualized__Table__headerRow {
    width: 100% !important;
    text-transform: inherit;
    height: auto !important;
    padding-top: 20px;
  }

  .ReactVirtualized__Table__row {
    width: 100% !important;
  }

  #vehicleManage .ReactVirtualized__Table__row, 
  #groupManage .ReactVirtualized__Table__row,
  #fenceManage .ReactVirtualized__Table__row,
  #driverManage .ReactVirtualized__Table__row,
  #clientManage .ReactVirtualized__Table__row,
  #clientManage .ReactVirtualized__Table__row,
  #placeManage .ReactVirtualized__Table__row {
    cursor: pointer;
  }

  .ReactVirtualized__Table__row:nth-child(even) {
    background: #FFFFFF;
  }

  .ReactVirtualized__Table__row:nth-child(odd) {
    background: #F5F6FF;
  }

  .ReactVirtualized__Table__row:hover {
    background: #F0F1FF;
  }

  .ReactVirtualized__Table__row:hover svg.icon-delete {
    color: #FD3995;
  }

  .ReactVirtualized__Table__row:focus {
    outline: none;
  }

  svg.icon-delete:hover {
    color: #FD3995;
  }

  .ReactVirtualized__Table__rowColumn {
    flex: 1 !important;
    display: flex;
    align-items: center;
    height: 100%;
  }

  /* PLACEHOLDER ANIMATION */
  @keyframes placeHolderShimmer {
    0% {
      background-position: 0px 0;
    }
    100% {
      background-position: 100em 0;
    }
  }

  /* PAGINATION COMPONENT */
  .MuiPaginationItem-page.Mui-selected {
    background-color: #2431a4 !important;
    color: white !important;
  }
  .MuiPaginationItem-root {
    color: #1d1b84 !important;
  }
  .MuiPaginationItem-icon + .MuiTouchRipple-root {
    background: #1d1b8440;
  }
  svg {
    overflow: inherit;
  }

  /* SPIN ANIMATION */
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(720deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(720deg); }
  }
  /* GOOGLE MAPS ICON */
  .gm-style-iw.gm-style-iw-c{
    background-color: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
  }
  .gm-ui-hover-effect, .gm-style .gm-style-iw-t::after {
    display: none !important;
  }
  .gm-style-iw-d{
    max-height: none !important;
    min-height: auto !important;
    display: flex !important;
    align-items: flex-end !important;
    overflow: visible !important;
    padding: 0px 0 5px !important;
  }
  .gm-style-iw-t {
    bottom: 0px !important;;
  }

  /* TOAST */
  .Toastify__toast {
    border-radius: 5px;
    padding: 16px;
  }

  /* CHANGELOGFY */
  #changelogfy_badge {
    right: -12px;
    bottom: 40px;
    left: auto !important;
  }
  /* MENU DROPDOWN */
  .MuiList-root {
    min-width: 120px;
  }
`;

const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopM: "1232px",
  laptopL: "1440px",
  desktop: "2560px"
};

const device = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopM: `(max-width: ${size.laptopM})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`
};

export { resetStyle, device };
